const state = () => ({
	userInformation: {
		name: '',
		phoneNumber: '',
		userId: '',
		role: 'AllUser',
		loggedIn: false,
		city: {
			id: 4,
			faName: 'مشهد',
			alternatives: ['mashhad'],
			key: 'mashhad',
		},
	},
	businessInfo: {},
	artistInfo: {},
	serviceInfo: [],
	timeInfo: {},
	redirectPathAfterLogin: '/',
});

export default state;
